export const MCCOST = 58800;
export const RPSCOST = 238800;
